import $ from './jquery.js';

$.fn.appendAround = function(){
    return this.each(function(){
    
        var $self = $( this ),
            att = "data-set",
            $parent = $self.parent(), 
            parent = $parent[ 0 ],
            attval = $parent.attr( att ),
            $set = $( "["+ att +"='" + attval + "']" );

        function isHidden( elem ){
            return $(elem).css( "display" ) === "none";
        }

        function appendToVisibleContainer(){
            if( isHidden( parent ) ){
                var found = 0;
                $set.each(function(){
                    if( !isHidden( this ) && !found ){
                        $self.appendTo( this );
                        found++;
                        parent = this;
                    }
                });
            }
        }
    
        appendToVisibleContainer();
    
        $(window).bind( "resize", appendToVisibleContainer );
    
    });
};

$(document).ready(function(){
    $('.rover').appendAround();
});
